import React from "react";
import { AddMasterDataProps } from "./Index";
import { Title } from "../../../../../stories/Title/Title";
import InputHoc from "../../../../common/Input/Index";
import { Keys } from "../../../../../utils/Enum.keys";
import { Operation } from "../../../../../utils/Enum.types";
import { TextField } from "@mui/material";
import {
  FormAutocomplete,
  formClasses,
} from "../../../../../styles/AutocompleteStyles";
import { handleMUISelectEvent } from "../../../../../utils/UtilFunctions";
import { TicketPriorityType } from "./queries/types";
import { Label } from "../../../../../stories/Label/Label";

const options = Object.values(TicketPriorityType);

const Add = ({
  formData,
  handleValueChange,
  meta,
  operation,
  setFormData,
}: AddMasterDataProps) => {
  return (
    <>
      <div className="master-data__add">
        <Title variant="subtitle1">{`${
          operation === Operation.CREATE ? "Add" : "Update"
        } Reason`}</Title>
        <div className="master-data__add--form">
          <InputHoc
            LabelName={`Reason`}
            values={formData.reason}
            name="reason"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleValueChange(e, meta)
            }
            onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
              if (e.key === Keys.ENTER) {
                const priority = document.getElementsByClassName(
                  formClasses.inputRoot
                );
                priority.length && (priority[0] as HTMLButtonElement).focus();
              }
            }}
            autoFocus
            required
          />
        </div>
        <div className="label-grid">
          <Label>Priority</Label>
          <FormAutocomplete
            className={formClasses.inputRoot}
            options={options}
            onKeyDown={(e) => {
              if (e.key === Keys.ENTER) {
                e.preventDefault();
                handleMUISelectEvent(e);
              }
            }}
            onChange={(e, newValue) => {
              setFormData({
                ...formData,
                priority: newValue as TicketPriorityType,
              });
            }}
            value={formData["priority"]}
            openOnFocus
            forcePopupIcon
            freeSolo
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                className={formClasses.formControlRoot}
              />
            )}
          />
        </div>
      </div>
    </>
  );
};

export default Add;
